import { Activity, ActivityWithPagination, User } from '../types/models'
import { Box, Button } from '@mui/material'
import React, { useLayoutEffect, useState } from 'react'
import { callAxios } from '../hooks/useAxios'
import { ActivityLine } from './ActivityLine'
import { DateTime } from 'luxon'
import { lang } from '../utils/lang'
import { Trans } from 'react-i18next'

export interface ActivityLogProps {
  user?: User
}

/**
 * User activity log.
 */
export function ActivityLog(props: ActivityLogProps): React.ReactElement {

  const { user } = props
  const [activities, setActivities] = useState<Activity[]>([])
  const [pageNumber, setPageNumber] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)

  const onUpdate = () => {
    callAxios<ActivityWithPagination>({
      url: user ? `/activity/${user.id}` : '/activity',
    }).then(res => {
      if (res.success) {
        setPageNumber(res.data.current_page)
        setTotalPages(res.data.total_pages)
        setActivities(res.data.activities.sort((a, b) => DateTime.fromISO(b.time).toMillis() - DateTime.fromISO(a.time).toMillis()))
      }
    })
  }

  const onFetchActivities = () => {
    if (pageNumber >= totalPages) {
      return
    }
    callAxios<ActivityWithPagination>({
      url: user ? `/activity/${user.id}/${pageNumber + 1}` : '/activity',
    }).then(res => res.success && res.data.activities.length !== 0 && setActivities(prev => [...prev, ...res.data.activities].sort((a, b) => DateTime.fromISO(b.time).toMillis() - DateTime.fromISO(a.time).toMillis())))
    setPageNumber(prevPageNunber => prevPageNunber + 1)
  }

  useLayoutEffect(() => {
    onUpdate()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let lastDate: string

  return (
    <Box sx={{
      border: '1px solid rgba(255,255,255,0.2)',
      p: 2
    }}>
      {
        activities.map(a => {
          let title = <></>
          const date = lang.dayNameAndNumber(DateTime.fromISO(a.time))
          const month = lang.monthNameShort(+lang.monthNumberFromString(DateTime.fromISO(a.time).toFormat('LLL')))
          const year = DateTime.fromISO(a.time).toFormat('yyyy')
          if (date !== lastDate) {
            lastDate = date
            title = <Box sx={{ my: 2, color: 'primary.main' }}>{date}, {month}, {year}</Box>
          }
          return <React.Fragment key={a.id}>{title}<ActivityLine activity={a}/></React.Fragment>
        })
      }
      {!(pageNumber >= totalPages) && <Button sx={{ mt: 3, mb: 2 }} fullWidth onClick={() => onFetchActivities()}>
          <Trans>More</Trans>
      </Button>}
    </Box>
  )
}
